export default __webpack_public_path__ + "static/media/asking.20b7878b.png";